<template>
  <main class="employee-page">
    <confirm-side-dialog
      label="Как создать сотрудника"
      v-if="showHintDialog"
      v-on:cancel="showHintDialog = false"
      class="employee-page__modal"
    >
      <br>
      <p>
        Самый первый сотрудник - это вы.
        Нажмите на иконку редактирования,
        чтобы заполнить информацию о себе.
        После редактирования данных нажмите кнопку «Сохранить».
      </p>
      <zoom-image
        v-bind:src="require('@/assets/img/help/new/employees/employees-1.png')"
        alt="создание сотрудника"
        class="employee-page__modal__img"
      />
      <p>
        Для того, чтобы создать нового сотрудника,
        нажмите кнопку «Добавить&nbsp;сотрудника».
      </p>
      <zoom-image
        v-bind:src="require('@/assets/img/help/new/employees/employees-2.png')"
        alt="создание сотрудника"
        class="employee-page__modal__img"
      />
      <b>Введите данные:</b>
      <ul>
        <li>ФИО сотрудника</li>
        <li>Роль в клинике</li>
        <li>Специализация (для роли Врач)</li>
        <li>Номер телефона</li>
        <li>Мессенджеры</li>
      </ul>
      <b>В блоке «Дополнительно» укажите:</b>
      <ul>
        <li>Дату рождения сотрудника</li>
        <li>ИНН</li>
        <li>СНИЛС</li>
        <li>Кресло приема (для роли врач)</li>
        <li>Шаг приема (для роли врач)</li>
        <li>Дополнительную информацию о сотруднике</li>
        <li>Доступ к системе</li>
      </ul>
      <p>
        В блоке Права отметьте галочками доступные сотруднику действия в МИС.
      </p>
      <p>После ввода всех данных нажмите кнопку «Сохранить».</p>
      <zoom-image
        v-bind:src="require('@/assets/img/help/new/employees/employees-3.png')"
        alt="создание сотрудника"
        class="employee-page__modal__img"
      />
    </confirm-side-dialog>
    <div class="employee-page__body">
      <router-link
        v-bind:to=backStepNavigation()
        class="employee-page__button-back"
      >
        Назад
      </router-link>
      <div class="employee-page__body__row">
        <h1 class="employee-page__title">
          <span>
            Сотрудники
          </span>
          <button
            type="button"
            v-on:click="showHintDialog = true; howToSetUpReachGoal()"
          >
            ? Как настроить
          </button>
        </h1>
        <next-step-setting-instruction
          v-bind:current-route-name="$route.name"
          v-bind:initial-steps="availableInstructionSteps"
        >
          <button
            class="employee-page__button"
            type="button"
            v-if="hasCreateEmployee"
            id="employer-button-create-parent"
            v-on:click="openEmployeeCreationDialog">Добавить сотрудника</button>
        </next-step-setting-instruction>
      </div>
      <div class="employee-page__filters">
        <input-text-search
          class="employee-page__search"
          v-model="match"
          placeholder="Введите ФИО или роль"
        />
        <template v-if="!filteringByDismissed">
          <input-checkbox
            class="employee-page__checkbox"
            title="С доступом в МИС"
            v-model="filteringByAccessAllowed" />
          <input-checkbox
            class="employee-page__checkbox"
            title="Выводится в расписании"
            v-model="filteringByEnableScheduling" />
        </template>
        <input-checkbox
          class="employee-page__checkbox"
          title="Уволен"
          v-model="filteringByDismissed" />
      </div>
      <div class="employee-page-table">
        <div class="employee-page-table__head">
          <div class="employee-page-table__cell">№</div>
          <div class="employee-page-table__cell">ФИО</div>
          <div class="employee-page-table__cell">Специализация</div>
          <div class="employee-page-table__cell">Роль</div>
          <div class="employee-page-table__cell">Кресло</div>
          <div
            v-if="filteringByDismissed"
            class="employee-page-table__cell">Дата увольнения</div>
          <div
            class="employee-page-table__cell"
            v-if="hasViewCdaCompleteness"
          >СЭМД</div>
          <div class="employee-page-table__cell" />
        </div>
        <div class="employee-page-table__body-mobile">
          <button
            class="employee-page-table__body-mobile__row"
            type="button"
            v-bind:key="id"
            v-for="({
              id,
              fullName,
              specialityName,
            }, index) in employeeList"
            v-on:click="openEmployeeEditProfile(id)">
            <dt>№</dt>
            <dd>{{ index + 1 }}</dd>
            <dt>ФИО</dt>
            <dd>{{ fullName }}</dd>
            <dt>Специализация</dt>
            <dd>{{ specialityName }}</dd>
          </button>
        </div>
        <div
          v-if="!this.isEmployeeListEmpty && !this.isAwaitRequest"
          class="employee-page-table__body"
        >
          <button
            class="employee-page-table__row"
            type="button"
            v-bind:key="employee.id"
            v-for="employee in employeeList"
            v-on:click="openEmployeeEditProfile(employee.id)">
            <div
              data-label="№"
              class="employee-page-table__cell number" />
            <div
              data-label="ФИО"
              class="employee-page-table__cell">{{ employee.fullName }}</div>
            <div
              data-label="Специализация"
              class="employee-page-table__cell">
              {{ employee.specialityName }}
            </div>
            <div
              data-label="Роль"
              class="employee-page-table__cell">
              {{ employee.roleName }}
            </div>
            <div
              v-if="!isAdmin(employee) && hasCabinet(employee)"
              data-label="Кресло"
              class="employee-page-table__cell">
              <div
                class="cabinet-color"
                v-bind:style="{ backgroundColor: employee.cabinet.color }" />
              {{ employee.cabinet.name }}
            </div>
            <div
              v-else
              data-label="Кресло"
              class="employee-page-table__cell" />
            <div
              v-if="filteringByDismissed"
              data-label="Дата увольнения"
              class="employee-page-table__cell">
              {{ employee.dismissedDate }}
            </div>
            <div
              class="employee-page-table__cell cda-completeness"
              data-label="Заполненность для СЭМД"
              v-bind:class="employee.cdaCompleteness"
              v-if="hasViewCdaCompleteness"
            >{{ employee.cdaCompleteness }}</div>
            <div
              class="employee-page-table__cell"
              data-label="Редактировать"
              v-if="hasViewEmployee"
            >
              <span id="employer-button-edit-parent" class="employee-page-table__icon-edit" />
            </div>
          </button>
        </div>
        <div
          v-else-if="!isAwaitRequest"
          class="employee-page-table__message"
        >
          Ничего не найдено
        </div>
      </div>
    </div>
    <on-boarding-dialog
      :is-page-ready="hasCreateEmployee"
      :is-show-screen="isShowOnBoardingDialog"
      :is-show-button-create-employer="isShowButtonCreateEmployer"
      :is-show-button-edit-employer="isShowButtonEditEmployer"
      @showed="showedOnboarding"
    >
      <button
        v-if="isShowButtonCreateEmployer"
        id="employer-button-create-child"
        class="employee-page__on-boarding__button"
        type="button">
        Добавить сотрудника
      </button>
      <span
        v-if="isShowButtonEditEmployer"
        id="employer-button-edit-child"
        class="employee-page-table__icon-show"
      />
    </on-boarding-dialog>
  </main>
</template>
<script>
import debounce from 'lodash.debounce';
import FocusMixin from '@/mixins/focusMixin';
import employeeProfileMixin from '@/mixins/employeeProfileMixin';
import InputCheckbox from '@/components/InputCheckbox.vue';
import notifierMixin from '@/mixins/notifierMixin';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import settingInstructionMixin from '@/mixins/settingInstructionMixin';
import NextStepSettingInstruction from '@/components/NextStepSettingInstruction.vue';
import ZoomImage from '@/components/ZoomImage.vue';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import onBoardingShowMixin from '@/mixins/onBoardingShowMixin';
import OnBoardingDialog from '@/components/OnBoardingDialog.vue';
import { GOAL_CLICK_HOW_TO_SET_UP_BUTTON } from '@/plugins/metric';

/**
 * @description Компонент раздела списка сотрудников.
 * @type {Vue}
 */
export default {
  components: {
    OnBoardingDialog,
    ZoomImage,
    NextStepSettingInstruction,
    InputCheckbox,
    ConfirmSideDialog,
    InputTextSearch,
  },
  computed: {
    /**
     * Показываем представление "Создать пользователя"
     *
     * @return {boolean}
     */
    isShowButtonCreateEmployer() {
      return this.step?.notShowedView === 'employer-button-create';
    },
    /**
     * Показываем представление "Редактирование пользователя"
     *
     * @return {boolean}
     */
    isShowButtonEditEmployer() {
      return this.step?.notShowedView === 'employer-button-edit';
    },
    /**
     * Показываем ОнБординг Окно
     *
     * @return {boolean}
     */
    isShowOnBoardingDialog() {
      return this.isShowButtonCreateEmployer || this.isShowButtonEditEmployer;
    },
    /**
     * @description Идентификаторы кабинетов.
     * @type {number[]}
     */
    initialCabinetIds() {
      return this.employeeProfile.fold([])((employee) => employee.cabinetIds);
    },
    hasCreateEmployee() {
      return this.actions.includes('create-edit-employee');
    },
    /**
     * @description Имеет право показа заполненности для СЭМД.
     */
    hasViewCdaCompleteness() {
      return this.actions.includes('view-cda-completeness-doctor');
    },
    hasViewEmployee() {
      return this.actions.includes('view-employee');
    },
    viewQuery() {
      return {
        filteringByAccessAllowed: this.filteringByAccessAllowed,
        filteringByDismissed: this.filteringByDismissed,
        filteringByEnableScheduling: this.filteringByEnableScheduling,
        match: this.match.substring(0, 225),
      };
    },
    /**
     * @description Является ли список сотрудников пустым.
     * @returns {boolean}
     */
    isEmployeeListEmpty() {
      return !Object.keys(this.employeeList).length;
    },
  },
  async created() {
    if (this.selectedEmployeeId) {
      this.openEmployeeEditProfile(this.selectedEmployeeId, false);
    }
    await this.fetchEmployeeProfileOptions();
    this.reloadEmployeeList();
  },
  updated() {
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonCreateEmployer,
      '#employer-button-create-parent',
      '#employer-button-create-child',
      'lb',
    );
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonEditEmployer,
      '#employer-button-edit-parent',
      '#employer-button-edit-child',
      'rt',
    );
  },
  data() {
    return {
      /**
       * @description Допустимые действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Список сотрудников.
       * @type {any[]}
       */
      employeeList: [],
      /**
       * @description Показывать форму создания сотрудника.
       * @type {boolean}
       */
      hasOpenEmployeeCreationDialog: false,
      /**
       * @description Ожидание выполнения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Совпадение.
       * @type {string}
       */
      match: '',
      /**
       * @description Фильтровать по доступу к системе.
       * @type {boolean}
       */
      filteringByAccessAllowed: false,
      /**
       * @description Фильтровать по уволенным сотрудникам.
       * @type {boolean}
       */
      filteringByDismissed: false,
      /**
       * @description Фильтровать по выводу в расписании.
       * @type {boolean}
       */
      filteringByEnableScheduling: false,
      /**
       * @description Нужно подтверждение перед закрытием формы сотрудника.
       * @type {boolean}
       */
      needConfirmBeforeCloseEmployeeForm: false,
      /**
       * @description Показывать диалоговое окно подсказки.
       * @type {boolean}
       */
      showHintDialog: false,
      /**
       * Слаг шага ОнБординга
       * @type {string}
       */
      stepSlug: 'insert-data-about-employers',
    };
  },
  methods: {
    /**
     * @description Открыть форму для создания сотрудника.
     * @returns {void}
     */
    openEmployeeCreationDialog() {
      this.$router.push({ name: 'ClinicPanelFormCreateEmployee' });
    },
    /**
     * @description Открыть страницу редактирования профиля сотрудника.
     * @param {number} id Идентификатор сотрудника.
     * @returns {void}
     */
    openEmployeeEditProfile(id) {
      this.$router.push({ name: 'ClinicPanelEmployeeProfileBasic', params: { id } });
    },
    /**
     * @description Перезагрузить данные списка сотрудников.
     * @returns {void}
     */
    reloadEmployeeList() {
      const onSuccess = ({ actions, employees, onBoardingStatus }) => {
        const { title, body } = onBoardingStatus;
        this.checkAndUpdate(title, body);
        this.actions = actions;
        this.employeeList = employees;
      };
      this.isAwaitRequest = true;
      this
        .$employeeGateway
        .getListForView(this.viewQuery)
        .then((result) => {
          result.fold(this.notifyFail, onSuccess);
          this.isAwaitRequest = false;
        });
    },
    /**
     * @description Является ли сотрудник администратором.
     * @param {any} employee Сотрудник.
     * @return {boolean}
     */
    isAdmin(employee) {
      return employee.roleName === 'Администратор' || employee.roleName.includes(', Администратор');
    },
    /**
     * @description Имеется ли у сотрудника выбранный кабинет.
     * @param {any} employee Сотрудник.
     * @return {boolean}
     */
    hasCabinet(employee) {
      return !!employee.cabinet.name;
    },
    /**
     * @description Обработать достижение цели нажатия на кнопку "Как настроить".
     * @return {void}
     */
    howToSetUpReachGoal() {
      this.$goal(GOAL_CLICK_HOW_TO_SET_UP_BUTTON);
    },
  },
  mixins: [
    FocusMixin,
    onBoardingShowMixin,
    onBoardingMixin,
    employeeProfileMixin,
    notifierMixin,
    settingInstructionMixin,
  ],
  name: 'ClinicPanelEmployeeList',
  props: {
    selectedEmployeeId: {
      default: () => null,
      required: false,
      type: Number,
    },
  },
  watch: {
    viewQuery: debounce(function fetch() { this.reloadEmployeeList(); }, 300),
  },
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";
.employee {
  &-page {
    display: flex;
    flex-direction: row;
    width: 100%;
    &__on-boarding {
      &__button {
        @include buttons.btn-blue(250px, 48px, 16px);
        max-width: 300px;
        height: 52px;
      }
    }
    &__button {
      @include buttons.btn-blue(100%, 48px, 16px);
      max-width: 250px;
      min-width: 180px;
    }
    &__body {
      padding: 38px 20px 160px 23px;
      width: 100%;
      overflow-y: scroll;
      &__row {
        align-content: center;
        display: flex;
        flex-direction: row;
        gap: 10px;
        justify-content: space-between;
      }
    }
    &__filters {
      align-items: flex-end;
      display: flex;
      flex-direction: row;
      gap: 15px;
      margin-top: 15px;
    }
    &__search {
      margin: 0;
      padding: 0;
      max-width: 400px;
      width: 100%;
    }
    &__checkbox {
      transform: translateY(9px);
    }
    &__title {
      display: flex;
      flex-flow: row wrap;
      align-items: baseline;
      gap: 10px 30px;
      button {
        font-size: 18px;
        font-weight: 500;
        color: #90a0b7;
        &:hover {
          color: #0489E0;
        }
      }
    }
    &__modal {
      &__img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
        margin: 15px 0;
      }
      p {
        margin-bottom: 10px !important;
      }
      b {
        display: inline-block;
        margin-bottom: 10px;
      }
      ol,
      ul {
        margin-bottom: 10px;
      }
    }
    &-table {
      counter-reset: counterEmployees;
      margin: 25px 0 0 0;
      &__body-mobile {
        display: none;
        flex-direction: column;
        gap: 10px;
        &__row {
          display: grid;
          font-size: 12px;
          grid-template-columns: auto 1fr;
          justify-items: flex-end;
          align-items: center;
          row-gap: 5px;
          padding: 5px;
          &:nth-child(odd) {
            background-color: var(--fill-color);
          }
          & > dt {
            justify-self: flex-start;
          }
          & > dd {
            text-align: right;
          }
        }
      }
      &__head,
      &__row {
        width: 100%;
        text-align: left;
        align-items: center;
        display: grid;
        font-size: 14px;
        grid-template-columns:
          40px
          repeat(3, minmax(200px, 1fr))
          minmax(144px, 200px)
          minmax(3rem, .5fr)
          repeat(2, 33px);
        line-height: 17px;
      }
      &__head {
        font-weight: 700;
        border-bottom: 2px solid #0489e0;
        padding: 10px 0;
      }
      &__row {
        border-bottom: 1px solid #eaeff3;
        padding: 12px 0;
        &:hover {
          background: #eaeff3;
        }
      }
      &__cell {
        padding: 0 8px;
        &.number:after {
          counter-increment: counterEmployees;
          content: counter(counterEmployees);
        }
        .cabinet-color {
          display: inline-block;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          margin: 0 5px 0 0;
        }
      }
      &__cell.cda-completeness {
        font-size: 0px;
        &::after {
          font-size: 1rem;
        }
        &.empty::after {
          content: '-';
        }
        &.full::after {
          content: '+';
        }
        &.unknown::after {
          content: '?';
        }
      }
      &__icon {
        &-edit {
          background-image: url("@/assets/img/pen-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;
          display: inline-block;
          height: 14px;
          margin: 0;
          padding: 0;
          width: 14px;
          &:hover {
            background-image: url("@/assets/img/pen-blue.svg");
          }
        }
        &-show {
          background-image: url("@/assets/img/pen-grey.svg");
          background-repeat: no-repeat;
          background-size: contain;
          cursor: pointer;
          display: inline-block;
          height: 16px;
          margin: 0;
          padding: 0;
          width: 16px;
          background-color: white;
          border-radius: 25%;
        }
        &-delete {
          background-image: url("@/assets/img/exit-grey.svg");
          background-size: contain;
          background-repeat: no-repeat;
          width: 12px;
          height: 12px;
          cursor: pointer;
          &:hover {
            background-image: url("@/assets/img/exit-blue.svg");
          }
        }
      }
      & &__payroll-link::after {
        color: var(--action-color);
        content: '\20b8';
        display: inline-block;
        font-size: 18px;
        font-weight: 400;
        text-align: center;
        text-decoration: none;
        width: 18px;
      }
      &__message {
        text-align: center;
        padding-top: 40px;
        font-size: 24px;
      }
    }
    &__button-back {
      color: var(--action-color);
      display: flex;
      align-items: center;
      gap: 7px;
      width: fit-content;
      text-decoration: none;
      &:before {
        content: '';
        background-image: url('@/assets/img/arrow/arrow-blue.svg');
        background-position: center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: block;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &-creation {
    &__buttons {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      max-width: 438px;
      width: 100%;
      margin: 10px 0 0 auto;
    }
    &__button {
      &-cancel {
        max-width: 219px;
        @include buttons.btn-transparent(100%, 56px, 20px);
      }
      &-save {
        max-width: 219px;
        @include buttons.btn-blue(100%, 56px, 20px);
        &:disabled {
          background-color: var(--unfocus-color);
          border-color: var(--unfocus-color);
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .employee {
    &-page {
      flex-direction: column;
      &__filters {
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
      }
      &__search {
        max-width: 100%;
      }
      &-table {
        &__head {
          display: none;
        }
        &__row {
          grid-template-columns: 1fr;
          grid-gap: 10px;
          margin: 0 0 20px 0;
        }
        &__cell {
          display: flex;
          justify-content: space-between;
          text-align: right;
          .cabinet-color {
            background-color: transparent !important;
          }
        }
        &__cell:before {
          content: attr(data-label);
          font-size: 14px;
          font-weight: 700;
          margin-right: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 640px) {
  .employee {
    &-page {
      &__body {
        padding: 38px 10px 140px;
        &__row {
          flex-direction: column;
        }
      }
      &__button {
        max-width: 100%;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .employee {
    &-page {
      &-table {
        &__body {
          display: none;
          &-mobile {
            display: flex;
          }
        }
        &__row {
          grid-template-columns: 1fr;
          grid-gap: 10px;
          margin: 0 0 20px 0;
        }
        &__cell {
          font-size: 12px;
          padding: 0;
        }
        &__cell:before {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
